import React from "react";
import { Slider as DebtSlider } from "@mui/material";
import { Button } from "@ADC/components/common";

const Step1 = ({
  handleSliderChange,
  setFormError,
  formError,
  debtValue,
  values,
  setStep,
  step,
  marksMobile,
}) => {
  const formatNumber = (text) => {
    return text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="w-auto">
      <h2 className="text-3xl text-sky-700 font-medium capitalize">
        how much debt do you owe?
      </h2>
      <div className="mt-4 mb-2">
        <h2 className="text-green-700 text-center text-7xl font-bold mb-3">
          ${formatNumber(debtValue)}
        </h2>
        <div className="px-4 text-center">
          <DebtSlider
            defaultValue={63000}
            min={10000}
            max={300000}
            marks={marksMobile}
            step={1000}
            onChange={handleSliderChange}
            sx={{
              fontSize: "1.0rem",
              color: "green",
              "& .MuiSlider-thumb": {
                color: "green",
                height: 28,
                width: 28,
              },
              "& .MuiSlider-track": {
                backgroundColor: "green",
                borderRadius: "0px",
              },
              "& .MuiSlider-rail": {
                backgroundColor: "green",
                borderRadius: "0px",
              },
              "& .MuiSlider-mark": {
                display: "none",
              },
            }}
          />
        </div>
      </div>
      {formError.debtValue ? (
        <p className="w-full flex justify-center items-center my-4 text-lg font-semibold text-custom-negative">
          {formError.debtValue}
        </p>
      ) : null}
      <h5 className="text-sky-700 text-xl sm:text-2xl mt-3 mb-5">
        Select Your Debt Amount
      </h5>
      <Button
        className="!py-0.5 !px-20 !rounded-lg !text-3xl mx-auto"
        label="Let's Go!"
        variant="primary"
        onPress={() => {
          if (values.debtValue) {
            if (step < 3) setStep(step + 1);
          } else {
            setFormError({
              ...formError,
              debtValue: "Please select a debt amount.",
            });
          }
        }}
      />
    </div>
  );
};

export default Step1;
